export const PLACEHOLDER_MAX_SIZE = 200;
